import React from 'react';
import { View, useWindowDimensions } from 'react-native';

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import { Icon } from '../../../../components/Icon';
import useActiveAdminCommunity from '../../../../hooks/useActiveAdminCommunity';
import CamerasGrid from './CamerasGrid';


export default function AccessCamerasScreen() {
  const { communityId } = useActiveAdminCommunity()
  const { width } = useWindowDimensions()

  // Columnas según el ancho de la ventana (descontando el sidebar ~ya implícito).
  const numColumns = width >= 1600 ? 4 : width >= 1150 ? 3 : 2

  return (
    <View style={tw`flex-1`}>
      {/* Header morado (mismo estilo que Accesos / Tags) */}
      <View style={tw`bg-secondary rounded-2xl row items-center px-4 py-3 mb-3`}>
        <Icon name="navAccesos" variant="white" width={24} height={20} />
        <View style={tw`ml-3`}>
          <Text style={tw`text-white font-600 text-lg`}>Cámaras</Text>
          <Text style={tw`text-white/80 text-sm`}>Ve en tiempo real lo que sucede dentro del fraccionamiento</Text>
        </View>
      </View>

      <CamerasGrid communityId={communityId} numColumns={numColumns} />
    </View>
  );
}
